import stickybits from 'stickybits';

stickybits('.js-sticky', { stickyBitStickyOffset: 180 });
